import { callAPI, HTTPMethod } from './API';
import { TenantFieldCatalog, TenantField, TenantAddress, TenantContact, TenantFieldBankAccount, TenantFieldsRequest, TenantFields, ProviderFieldsResponse, ProviderFieldsRequest, FieldPriorityRequest } from '../model/TenantFieldCatalog';

const basePath = (tenantId: string) => `/tenants/${tenantId}/tenant-fields`;

const basePathProvider = (tenantId: string) => `${basePath(tenantId)}/provider-fields`;

export async function providerFields(tenantId: string): Promise<ProviderFieldsResponse> {
  return await callAPI(basePathProvider(tenantId), {
    method: HTTPMethod.GET,
  });
}

export async function avalaibleProviderFields(tenantId: string): Promise<ProviderFieldsResponse> {
  return await callAPI(`${basePath(tenantId)}/available-provider-fields`, {
    method: HTTPMethod.GET,
  });
}

export async function updatePriority(tenantId: string, request: FieldPriorityRequest): Promise<ProviderFieldsResponse> {
  return await callAPI(basePathProvider(tenantId), {
    method: HTTPMethod.PUT,
    body: request,
  });
}

export async function deleteField(tenantId: string, id: string): Promise<void> {
  return await callAPI(`${basePathProvider(tenantId)}/${id}`, {
    method: HTTPMethod.DELETE,
  });
}

export async function addFieldConfiguration(tenantId: string, request: ProviderFieldsRequest): Promise<ProviderFieldsResponse> {
  return await callAPI(`${basePathProvider(tenantId)}`, {
    method: HTTPMethod.POST,
    body: request
  });
}